"use client";

import { useState, useEffect } from "react";
import HeroSection from "@/components/About/HeroSection";
import PartnerMarquee from "@/components/About/PartnerMarquee";
import CorporateBio from "@/components/About/CorporateBio";
import SolutionGrid from "@/components/About/SolutionGrid";
import IndustryVerticals from "@/components/About/IndustryVerticals";
import CoreValues from "@/components/About/CoreValues";
import CtaBanner from "@/components/About/CtaBanner";

export default function AboutPageContent() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Always render the same structure to avoid hydration mismatch
  // Use opacity transition instead of conditional rendering
  return (
    <main 
      className={`font-sans text-midnight_text dark:text-white bg-white dark:bg-darkmode overflow-hidden transition-opacity duration-300 ${
        mounted ? "opacity-100" : "opacity-0"
      }`}
    >
      <HeroSection />
      <PartnerMarquee />
      <CorporateBio />
      <SolutionGrid />
      <IndustryVerticals />
      <CoreValues />
      <div className="py-8 px-6 pb-10">
        <CtaBanner />
      </div>
    </main>
  );
}

